import { render, staticRenderFns } from "./GlobalHeader.vue?vue&type=template&id=c0461460&"
import script from "./GlobalHeader.vue?vue&type=script&lang=js&"
export * from "./GlobalHeader.vue?vue&type=script&lang=js&"
import style0 from "./GlobalHeader.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports